module.exports = __webpack_public_path__ + "img/bg-bottom.8d2de8d6.png";